module.exports = __webpack_public_path__ + "assets/icn-theme.50fe6fe9.svg";